import { z } from 'zod'

// Модальность режима Endel. У «активностей» её нет — они переиспользуют чужие
// саундбанки, и своя группа в UI им подходит больше выдуманной модальности.
export const ModalitySchema = z.enum(['focus', 'relax', 'sleep'])
export type Modality = z.infer<typeof ModalitySchema>

export const SoundscapeSchema = z.object({
  slug: z.string(),
  title: z.string(),
  modality: z.union([ModalitySchema, z.literal('')]),
  kind: z.enum(['mode', 'activity']),
})
export type Soundscape = z.infer<typeof SoundscapeSchema>

export const SOUNDSCAPE_GROUPS = [
  { key: 'focus', title: 'Фокус' },
  { key: 'relax', title: 'Релакс' },
  { key: 'sleep', title: 'Сон' },
] as const

export interface SoundscapeGroup {
  key: string
  title: string
  items: Soundscape[]
}

// Группировка для ряда кружков: режимы идут по модальности, остальное — в конец.
// Пустые группы отбрасываем, чтобы ряд не рвался заголовком без содержимого.
export function groupSoundscapes(list: Soundscape[]): SoundscapeGroup[] {
  const groups: SoundscapeGroup[] = SOUNDSCAPE_GROUPS.map((g) => ({
    key: g.key,
    title: g.title,
    items: list.filter((s) => s.modality === g.key),
  }))

  const rest = list.filter((s) => s.modality === '')
  if (rest.length > 0) {
    groups.push({ key: 'other', title: 'Другое', items: rest })
  }
  return groups.filter((g) => g.items.length > 0)
}

// Точка возврата в режиме: смещение от начала суточного микса. Сам звук за ним
// каждый раз новый — микс генеративный, повторяется только время звучания.
export const SoundscapePositionSchema = z.object({
  slug: z.string(),
  positionSeconds: z.number(),
  updatedAt: z.string(),
})
export type SoundscapePosition = z.infer<typeof SoundscapePositionSchema>

// Статистика фокуса: сервер отдаёт секунды, формат — дело клиента.
export const FocusStatsSchema = z.object({
  todaySeconds: z.number(),
  weekSeconds: z.number(),
  totalSeconds: z.number(),
})
export type FocusStats = z.infer<typeof FocusStatsSchema>
